let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6yy0")).then(() => parcelRequire('f4z0c'));